import { useState, useMemo } from "react";
import { BiBell } from "react-icons/bi";
import { Badge, Tabs, Typography } from "antd";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { Container, Content } from "./styles";
import AntButton from "../../components/Button";
import { useAuth } from "../../contexts/AuthContext";
import { Proventos } from "../../components/Proventos";
import { Carteira } from "../../components/MeusInvestimentos/index";
import { useNotification } from "../../contexts/NotificationContext";
import { NotificationDrawer } from "../../components/Notification/Notification";
import { Avisos } from "../../components/MeusInvestimentos/Avisos";
import { useBroker } from "../../contexts/BrokerContext";
import { isMobile } from "../../utils";

interface CarteiraProps {}

export const Wallet: React.FC<CarteiraProps> = () => {
  const { notification } = useNotification();
  const { integration } = useBroker();
  const {
    user,
    hasPlan: hasPremiunPlan,
    hasPermissionExterior,
    hasPermissionGeneral,
  } = useAuth();
  
  // Lógica corrigida para verificação do plano
  const hasPlan = useMemo(() => {
    // Verifica se tem plano premium através do contexto
    const hasPremiumFromContext = hasPremiunPlan || hasPermissionExterior || hasPermissionGeneral;
    
    // Verifica se tem plano ativo diretamente do objeto do usuário
    const hasActivePlan = user?.user?.userPlanInfoVelotax?.active === true;
    
    // Verifica se o tipo do plano é premium (não é BASIC)
    const isPremiumType = user?.user?.userPlanInfoVelotax?.type && 
      !user.user.userPlanInfoVelotax.type.includes('BASIC');
    
    // Verifica se o plano não expirou
    const isPlanNotExpired = user?.user?.userPlanInfoVelotax?.dueDate && 
      new Date(user.user.userPlanInfoVelotax.dueDate) > new Date();
    
    return hasPremiumFromContext || (hasActivePlan && isPremiumType && isPlanNotExpired);
  }, [hasPremiunPlan, hasPermissionExterior, hasPermissionGeneral, user?.user?.userPlanInfoVelotax]);

  const [notificationDrawerOpen, setNotificationDrawerOpen] = useState(false);
  const [hideValues, setHideValues] = useState(false);

  return (
    <Container className="velotax-container">
        <Content className="velotax-content carteira">
      <div className="header">
        <Typography.Title level={1} className="page-title">
          Meus investimentos
          <AntButton
            type="link"
            size="large"
            className="hide-values-btn"
            icon={hideValues ? <BsEyeSlash /> : <BsEye />}
            onClick={() => setHideValues((value) => !value)}
          />
        </Typography.Title>
        {hasPlan && (
          <div className="notification-button">
            <Badge
              size="small"
              showZero={false}
              offset={isMobile() ? [-12, -4] : [-12, 48]}
              

              count={notification?.filter((n) => !n.viewed)?.length || 0}
            >
              <AntButton
                loading={false}
                icon={<BiBell />}
                onClick={() => {
                  setNotificationDrawerOpen(true);
                }}
              />
            </Badge>
          </div>
        )}
      </div>
    
        <Avisos />
        {(!integration.integrated && !user.user.isIntegratedExterior) ? (<></>) : (
        <Tabs className="tabs-wallet">
          <Tabs.TabPane tab="INVESTIMENTOS" key="item-1">
            <Carteira hideValues={hideValues} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="PROVENTOS" key="item-2">
            <Proventos hideValues={hideValues} />
          </Tabs.TabPane>
        </Tabs>
        )}
      </Content>
      <NotificationDrawer
        open={notificationDrawerOpen}
        onClose={() => setNotificationDrawerOpen(false)}
      />
    </Container>
  );
};
